import { ISpotlightItem } from "@/interfaces/spotlight";
import { BasicButton } from "thrive-components";

const SpotlightCard = ({item} : {item:ISpotlightItem}) => {   

    const {image, title, link, body} = item;

    return (
        <div className="spotlight-card">
            <div className="spotlight-image-wrapper">
                <img
                    src={image.uri}
                    className="spotlight-image"
                    alt={title}
                />
            </div>

            <div className="spotlight-information">
                <h2>{title}</h2>

                <span>{body}</span>

                {link?.text && 
                    <BasicButton 
                        className="spotlight-button-link" 
                        content={`${link.text} →`} 
                        isLink 
                        linkUrl={link?.uri} 
                        ariaLabel={link?.label ?? "Open link"} 
                        openInNewTab
                    />
                }
            </div>
        </div>
    );
}

export default SpotlightCard